import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MatPaginator, MatSort, MatTableDataSource, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-inherit-smtp',
  templateUrl: './inherit-smtp.component.html',
  styleUrls: ['./inherit-smtp.component.css']
})
export class InheritSMTPComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, public dialogRef: MatDialogRef<InheritSMTPComponent>) {     
  }
  
  dataSource: MatTableDataSource<any>;
  @ViewChild("paginator") paginator: MatPaginator;
  @ViewChild("sort") sort: MatSort;
  smtp_super:any
  selected:any
  type:number = parseInt(sessionStorage.getItem('type'))
  displayedColumns2 = [
    "id",
    "Agent_id",
    "username",
    "smtp",
    "action"
  ];

  ngOnInit() {
    this.smtp_super= this.data.res
    if(this.type==5){
      if(this.data.agtype==0){
        this.smtp_super.forEach((element:any) => {
          switch(element.emailtype){
            case 0:{
              element.smtp="Gmail";
              break
          }
          case 1:{
            element.smtp="Outllook";
      
              break
          }
          case 2:{
            element.smtp="Yahoo";
              break
          }
          case 3:{
            element.smtp="Hotmail";
              break
            }
          case 4:{
            element.smtp="Other";
              break
            }
          }
        });
      }else{
        this.dataSource = new MatTableDataSource(this.data.res);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    }else{
      console.log(this.data);
      
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }

  }

  Close()
  {
    this.dialogRef.close(null);    
  }
  submit(){
    console.log(this.selected);
    this.dialogRef.close(this.selected);    
  }
  action_SMTP(status:number,id:any){
    this.dialogRef.close({status:status,id:id});  

  }
}
